import { lazy } from "react";

const Dashboard = lazy(() => import("pages/dashboard"));
const Cctv = lazy(() => import("pages/cctv/CctvPage"));
const ListUser = lazy(() => import("pages/setting/UserSetting"));
const BackOffice = lazy(() => import("pages/back-office"));

const ChangePassword = lazy(() => import("pages/setting/profile/ChangePassword"));

const Datalake = lazy(() => import("pages/datalake"));
const DataWarehouse = lazy(() => import("pages/data-warehouse"));
const Datasets = lazy(() => import("pages/datasets"));
const ListRole = lazy(() =>
  import("pages/setting/RoleSetting").then((r) => ({ default: r.RoleSetting }))
);

const ListMenu = lazy(() => import("pages/setting/MenuSetting/MenuSetting"));
const CreateMenu = lazy(() => import("pages/setting/MenuSetting/CreateMenu"));
const EditMenu = lazy(() => import("pages/setting/MenuSetting/EditMenu"));
const SortMenu = lazy(() => import("pages/setting/MenuSetting/SortMenu"))

const ListPermission = lazy(
  () => import("pages/setting/PermissionSetting/PermissionSetting")
);
const CreatePermission = lazy(
  () => import("pages/setting/PermissionSetting/CreatePermission")
);
const EditPermission = lazy(
  () => import("pages/setting/PermissionSetting/EditPermission")
);

const CctvDetailPage = lazy(() => import("pages/cctv/CctvDetailPage"));

const EditConfig = lazy(() => import("pages/setting/ConfigSetting/EditConfig"));
export {
  BackOffice,
  Cctv,
  CctvDetailPage,
  ChangePassword,
  CreateMenu,
  CreatePermission,
  Dashboard,
  Datalake,
  Datasets,
  DataWarehouse,
  EditConfig,
  EditMenu,
  EditPermission,
  ListMenu,
  ListPermission,
  ListRole,
  ListUser,
  SortMenu,
};
